import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  InputLabel,
  TextField,
  FormControl,
  FormLabel,
  Grid,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import ErrorMessage from '../../common/error-message';

function BaseEditTargetDeploymentModal({
  open, handleClose, handleSave, currentTargetDeployment,
}) {
  const {
    _id: currentId, marketId, target, effectiveOn,
  } = currentTargetDeployment;

  const [targetValue, setTargetValue] = useState(target);
  const [effectiveOnDate, setEffectiveOnDate] = useState(effectiveOn);
  const [errorMessage, setErrorMessage] = useState('');

  const onSave = () => {
    if (!targetValue || targetValue < 1) {
      return setErrorMessage('Please enter a positive number for target quantity.');
    }
    if (!effectiveOnDate) {
      return setErrorMessage('Please enter an effective date.');
    }
    setErrorMessage('');
    return handleSave(currentId, targetValue, effectiveOnDate, marketId);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <InputLabel>
              Quantity
            </InputLabel>
            <TextField
              margin="dense"
              name="target"
              type="number"
              value={targetValue}
              variant="standard"
              fullWidth
              InputProps={{ inputProps: { min: 1 } }}
              error={targetValue < 1 || Number.isNaN(targetValue)}
              onChange={(e) => setTargetValue(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <FormControl component="fieldset" style={{ width: '100%' }}>
              <FormLabel component="legend">Start Date</FormLabel>
              <DatePicker
                value={moment(effectiveOnDate)}
                name="effectiveOn"
                autoOk
                format="MMMM Do"
                onChange={(newDate) => setEffectiveOnDate(newDate.format())}
              />
            </FormControl>
          </Grid>
          {errorMessage && (
            <Grid item>
              <ErrorMessage errorMessage={errorMessage} />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={() => onSave()} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

BaseEditTargetDeploymentModal.defaultProps = {};
BaseEditTargetDeploymentModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  market: PropTypes.shape({
    _id: PropTypes.string,
    tz: PropTypes.string,
  }).isRequired,
  currentTargetDeployment: PropTypes.shape({
    _id: PropTypes.string,
    marketId: PropTypes.string,
    effectiveOn: PropTypes.string,
    target: PropTypes.number,
  }).isRequired,
};

const EditTargetDeploymentModal = withRouter(BaseEditTargetDeploymentModal);
export { BaseEditTargetDeploymentModal, EditTargetDeploymentModal };
